<template>
  <!-- test data :: <pre>{{ transactions }}</pre>  -->
  <Background>
    <div class="content-wrapper">
      <div class="image-wrapper">
        <img
          src="@/assets/header/PBT DI SELURUH MALAYSIA.png"
          alt="PBT DI SELURUH MALAYSIA"
          class="pbt-image"
        >
  
        <div class="line-under-image" />
      </div>
      

      <div class="map-gap" />

      <div class="pbtpay-status">
        <h2>PBT DI SELURUH MALAYSIA</h2>
        <MapNew />
      </div>
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from '@/components/background/background.vue'
import Menu from '@/components/menu-items/utama-menu.vue'




definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

// async function loadDataFromApiPbtPay() {
//   try {
//     const response = await httpGet('pengurusan-maklumat/pbtpay')

//     allData.value = response.data[0]

 
//     pbtPay.value = {
//       date: moment(allData.value.pdate).toDate(),
//       users: numberWithCommas(allData.value.users),
//       pbttaksiran: allData.value.pbttaksiran,
//       pbtkompaun: allData.value.pbtkompaun,
//       pbtsewa: allData.value.pbtsewa,
//       pbtpelbagai: allData.value.pbtpelbagai,
//       pbtosc: allData.value.pbtosc,
//       pbtpaypbtcount: allData.value.pbtcountlive,
//       overallPbtCount: allData.value.pbtcount,
//       pbtosccount: allData.value.pbtcountosc,
//       totalall: allData.value.totalall,
//       totaltrx: numberWithCommas(allData.value.totaltrx),
//       registered: numberWithCommas(allData.value.registered),
//       kutipanTahun: {},
//     }

//   } catch (err) {
//     console.error('loadDataFromApiPbtPay failed:', err)
//   }


// }

// onMounted(() => {
//   loadDataFromApiPbtPay()
// })
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  inline-size: 100%;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; 
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}


.map-gap {
  margin-block: 10px;
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
  
}

.pbtpay-status {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block-end: 50px;
  max-inline-size: 1200px;
}

.pbtpay-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: auto;
  max-inline-size: 900px;
}

.image-container img {
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}


.text-overlay {
  position: absolute;
  color: #fff;
  font-family: Arial, sans-serif;
  inset-block-start: 50%;
  inset-inline-start: 10%;
  text-align: start;
  transform: translateY(-50%);
}


.text-overlay-right {
  position: absolute;
  color: #fff;
  font-family: Arial, sans-serif;
  inset-block-start: 50%;
  inset-inline-end: 10%;
  text-align: end;
  transform: translateY(-50%);
}

.text-overlay h3,
.text-overlay-right h3 {
  margin: 0;
  color: white;
  font-size: 36px;
  font-weight: bold;
}

.text-overlay p,
.text-overlay-right p {
  margin: 0;
  font-size: 64px;
  font-weight: bold;
  line-height: 1.2;
}



@media (max-width: 768px) {
  .pbtpay-box {
    flex-direction: column;
    align-items: center;
  }

  h1 {
    font-size: 1.5rem;
  }

  .text-overlay h3,
  .text-overlay-right h3 {
    font-size: 4vw;
  }

  .text-overlay p,
  .text-overlay-right p {
    font-size: 7vw; 
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .pbtpay-item h2 {
    font-size: 1.5rem;
  }

  .text-overlay h3,
  .text-overlay-right h3 {
    font-size: 4vw;
  }

  .text-overlay p,
  .text-overlay-right p {
    font-size: 6vw; 
  }
}
</style>
